<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title mb-4">Request Approval</div>
    </div>
</div>